function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  width: "68",
  height: "68",
  viewBox: "0 0 68 68"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
  id: "b",
  width: "48",
  height: "48",
  rx: "24"
}), /*#__PURE__*/React.createElement("rect", {
  id: "c",
  width: "48",
  height: "48",
  rx: "24"
}), /*#__PURE__*/React.createElement("filter", {
  id: "a",
  width: "183.3%",
  height: "183.3%",
  x: "-41.7%",
  y: "-41.7%",
  filterUnits: "objectBoundingBox"
}, /*#__PURE__*/React.createElement("feOffset", {
  in: "SourceAlpha",
  result: "shadowOffsetOuter1"
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  in: "shadowOffsetOuter1",
  result: "shadowBlurOuter1",
  stdDeviation: "5"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "shadowBlurOuter1",
  result: "shadowMatrixOuter1",
  values: "0 0 0 0 0.06 0 0 0 0 0.06 0 0 0 0 0.06 0 0 0 0.3 0"
}), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
  in: "shadowMatrixOuter1"
}), /*#__PURE__*/React.createElement("feMergeNode", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  filter: "url(#a)",
  transform: "translate(10 9.884)"
}, /*#__PURE__*/React.createElement("use", {
  fill: "#FFFAED",
  xlinkHref: "#b"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24 1c12.702 0 23 10.298 23 23S36.702 47 24 47 1 36.702 1 24 11.298 1 24 1z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2",
  d: "M13 19.5a.5.5 0 110 1 .5.5 0 010-1m22 0a.5.5 0 100 1 .5.5 0 000-1M15 38a9 9 0 0118 0"
}), /*#__PURE__*/React.createElement("rect", {
  width: "46",
  height: "46",
  x: "1",
  y: "1",
  stroke: "#FABE28",
  strokeWidth: "2",
  rx: "23"
}))));